import type { AnalyticsEvent } from '@jane/shared-ecomm/types';
import { postMessageToIframeParent } from '@jane/shared/util';

export const postAnalyticsEvent = (payload: AnalyticsEvent) => {
  postMessageToIframeParent({
    messageType: 'analyticsEvent',
    payload,
  });
};
